exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".category-title{margin-top:10px;text-align:center}.questions{list-style:none}.question-card{width:500px;margin:5px auto}", ""]);

// exports
